import { EntitiyDefinition, FieldDefinitions } from '../DataProvider';
import { EMode } from '../Enums/EMode.enum';

import { InputCustomField } from './InputCustomField.entity';

export class InputLetterTemplateGroup<T extends EMode = EMode.entity> {
  /** Alias: code */
  code?: any;
  /** Alias: name */
  name?: any;
  /** Alias: groupIndex */
  groupIndex?: any;
  /** Alias: customFields */
  customFields?: InputCustomField<T>[];

  __typename?: string;
}

const fields: FieldDefinitions<InputLetterTemplateGroup> = {
  code: {
    alias: 'code',
  },
  name: {
    alias: 'name',
  },
  groupIndex: {
    alias: 'groupIndex',
  },
  customFields: {
    alias: 'customFields',
  },
  __typename: {
    alias: '__typename',
  },
};

export const inputLetterTemplateGroupEntityDefinition: EntitiyDefinition<InputLetterTemplateGroup> =
  {
    local: {},
    remote: {
      queryName: '',
      fragmentName: 'InputLetterTemplateGroup',
      withPaginationWrapper: false,
    },
    fieldDefinitions: fields,
  };
